// extracted by mini-css-extract-plugin
export default {"logo":"PrivacyPolicy_logo__u9A1m","wrapper":"PrivacyPolicy_wrapper__hrnsZ","title":"PrivacyPolicy_title__EPzAo","text":"PrivacyPolicy_text__GJhaR"};